import React from 'react';

import { Shimmer } from '~/ui/components';
import {
  Clock,
  DownloadFile,
  InfoCircle,
  MoneyWithDraw,
  Refresh,
  Replay,
  Sms,
  SwapHoriz,
  Warning,
} from '~/ui/assets/icons';
import { Loans } from '~/typings/enums/LoanType';

import { ContractView } from '../../ContractTab';
import { Grid, GridContainer, GridTitle, Tile, TileIcon, TileTitle, TileTop } from './ContractTilesGrid.styled';

type TileConfig = {
  key: ContractView;
  title: string;
  icon: React.ReactNode;
  loanTypes?: Loans[];
};

const TILES: TileConfig[] = [
  { key: 'installments', title: 'Parcelas', icon: <MoneyWithDraw /> },
  { key: 'additionalInfo', title: 'Informações adicionais', icon: <InfoCircle /> },
  { key: 'files', title: 'Arquivos', icon: <DownloadFile /> },
  { key: 'comments', title: 'Comentários', icon: <Sms /> },
  { key: 'pendencies', title: 'Pendências', icon: <Warning /> },
  { key: 'history', title: 'Histórico', icon: <Clock /> },
  { key: 'returns', title: 'Retornos', icon: <Replay /> },
  {
    key: 'ported',
    title: 'Contratos Portados',
    icon: <SwapHoriz />,
    loanTypes: ['PORTABILITY', 'PORTABILITYWITHOUTREFIN'],
  },
  { key: 'refinanced', title: 'Contratos Refinanciados', icon: <Refresh />, loanTypes: ['REFIN'] },
];

export type ContractTilesGridProps = {
  loading?: boolean;
  loanType?: Loans;
  onNavigate: (view: ContractView) => void;
};

export function ContractTilesGrid({ loading, loanType, onNavigate }: ContractTilesGridProps) {
  const visibleTiles = TILES.filter((tile) => !tile.loanTypes || (loanType && tile.loanTypes.includes(loanType)));

  return (
    <GridContainer>
      <GridTitle>Mais detalhes do contrato</GridTitle>
      <Grid>
        {visibleTiles.map((tile) => (
          <Tile key={tile.key} $disabled={loading} onClick={!loading ? () => onNavigate(tile.key) : undefined}>
            {loading ? (
              <>
                <TileTop>
                  <Shimmer height={16} width={80} br={4} />
                  <Shimmer height={24} width={24} br={4} />
                </TileTop>
                <Shimmer height={14} width={100} br={4} />
              </>
            ) : (
              <TileTop>
                <TileTitle>{tile.title}</TileTitle>
                <TileIcon>{tile.icon}</TileIcon>
              </TileTop>
            )}
          </Tile>
        ))}
      </Grid>
    </GridContainer>
  );
}
